import React from 'react';
import { styled, Shape, CustomLink, LazyImage, Caption } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CategoryItem = styled.div`
  text-align: center;
  padding: 4px;
`;
const Container = styled.div`
  width: '100%';
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const changeDisplayOrderCategoryList = (categoryList) => {
  const size = categoryList.length;
  const evenNumbers = [];
  const oddNumbers = [];
  for (let i2 = 0; i2 < size; i2++) {
    if (i2 % 2 === 0) {
      evenNumbers.push(i2);
    } else {
      oddNumbers.push(i2);
    }
  }
  const result = new Array(size);
  let i = 0;
  evenNumbers.forEach((index) => {
    result[index] = categoryList[i++];
  });
  oddNumbers.forEach((index) => {
    result[index] = categoryList[i++];
  });
  return result;
};
const CustomCategoryList = (_a) => {
  var _b = _a, {
    categoryList,
    colNum = 4,
    iconSize = 48,
    regionName,
    targetName,
    rowNum = 2
  } = _b, props = __objRest(_b, [
    "categoryList",
    "colNum",
    "iconSize",
    "regionName",
    "targetName",
    "rowNum"
  ]);
  if (!(categoryList == null ? void 0 : categoryList.length))
    return null;
  const flow = (categoryList == null ? void 0 : categoryList.length) < colNum * rowNum ? "row" : "column";
  const displayCategory = flow === "column" ? changeDisplayOrderCategoryList(categoryList) : categoryList;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Shape, __spreadValues({
    style: {
      display: "grid",
      gridTemplateRows: `repeat(${rowNum}, auto)`,
      gridTemplateColumns: `repeat(${colNum}, auto)`,
      gridAutoFlow: flow
    }
  }, props), displayCategory.map((category, index) => /* @__PURE__ */ React.createElement("div", {
    key: index,
    style: {
      width: `calc((100vw - 2rem)/${colNum})`,
      flexShrink: 0
    }
  }, /* @__PURE__ */ React.createElement(CustomLink, __spreadProps(__spreadValues({
    key: index
  }, category.link), {
    as: category.as
  }), /* @__PURE__ */ React.createElement(CategoryItem, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName,
    contentName: category.id,
    target: targetName,
    index
  })), /* @__PURE__ */ React.createElement(LazyImage, {
    contain: true,
    width: iconSize,
    height: iconSize,
    imageWidth: 80,
    src: category.imgUrl,
    borderRadius: 4,
    alt: category.name
  }), /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    line: 2,
    marginTop: "s4"
  }, category.name)))))));
};

export { CustomCategoryList };
